import { FP } from "../deps"

export enum ShopId {
  SellalongDevelopment = "53156151463",
  BuyMeOnce = "27219324",
  Sirplus = "8629350",
}

const shopIdLookup: Readonly<Record<string, ShopId>> = FP.function.pipe(
  ShopId,
  FP.readonlyRecord.toReadonlyArray,
  FP.readonlyArray.map(FP.readonlyTuple.swap),
  FP.readonlyRecord.fromFoldable(
    FP.semigroup.first<keyof typeof ShopId>(),
    FP.readonlyArray.Foldable
  ),
  FP.readonlyRecord.map((value) => ShopId[value])
)

export const toShopId: (input: string | null) => FP.option.Option<ShopId> =
  FP.function.flow(
    FP.option.fromNullable,
    FP.option.chain((shopId) =>
      FP.function.pipe(shopIdLookup, FP.readonlyRecord.lookup(shopId))
    )
  )

export {
  applyDiscountCode,
  clearDiscountCode,
  getCart,
  updateCart,
} from "./api"
